import { jsPDF } from "jspdf";
import { SECTIONS, FORECAST_ROWS, visibleFields } from "@/lib/ideation";
import { loadBrand, brandPages, PAGE_TOP, PAGE_BOTTOM } from "@/lib/pdfBrand";

const val = (a, k) => (a[k]?.unknown ? `Not yet known${a[k].why ? `: ${a[k].why}` : ""}` : (a[k]?.v || "").trim() || "[Not answered]");

const rows = (plan) => {
  const a = plan.answers || {};
  return SECTIONS.map(([id, title, fields]) => {
    if (id === "forecast") {
      return [title, (plan.forecast || []).flatMap((y, i) => FORECAST_ROWS.map(([k, l]) => [`Year ${i + 1} ${l} (${y.basis || "basis not set"}, GBP)`, y[k] === "" || y[k] == null ? "[Not answered]" : `£${Number(y[k]).toLocaleString("en-GB")}`]))];
    }
    return [title, visibleFields(fields, a).map(([k, l]) => [l, val(a, k)])];
  });
};

const meta = (plan, business, user) => [`Business: ${(plan.answers?.business_name?.v || "").trim() || business}`, `Applicant: ${user}`, `Version: ${plan.version ? `v${plan.version}` : "draft"}`,
  `Submitted: ${plan.submitted_at ? new Date(plan.submitted_at).toLocaleDateString("en-GB") : "not submitted"}`, `Exported: ${new Date().toLocaleString("en-GB")}`];

const founderLines = (plan) => (plan.founders || []).map((f, i) => `Founder ${i + 1}: ${f.name || "[name]"} · ${f.role || "[role]"} · ${f.email || "[email]"} · ${f.phone || "[phone]"} · Experience: ${f.experience || "[not given]"}`);

export const exportPdf = async (plan, business, user) => {
  const brand = await loadBrand();
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  let y = PAGE_TOP;
  const line = (t, size = 10, bold = false, color = 30) => {
    const parts = doc.setFont("helvetica", bold ? "bold" : "normal").setFontSize(size).splitTextToSize(t, 174);
    if (y + parts.length * size * 0.45 > PAGE_BOTTOM) { doc.addPage(); y = PAGE_TOP; }
    doc.setTextColor(color).text(parts, 18, y);
    y += parts.length * size * 0.45 + 2;
  };
  line("Ideation Plan", 18, true);
  line("The information on this form will be treated as strictly confidential by Westmont Enterprise Hub and UWL.", 9, false, 100);
  meta(plan, business, user).forEach((m) => line(m, 9, false, 100));
  y += 3;
  line("Founders", 12, true);
  founderLines(plan).forEach((f) => line(f));
  rows(plan).forEach(([title, items]) => {
    y += 3;
    line(title, 12, true, 31);
    items.forEach(([q, a]) => { line(q, 10, true); line(a, 10, false, a.startsWith("[Not") ? 150 : 40); });
  });
  y += 4;
  line("Evidence index: supporting files are kept in a separate controlled bundle in the workspace and are not embedded in this document.", 8, false, 120);
  brandPages(doc, brand, "Ideation Plan · Westmont Enterprise Hub");
  doc.save(`ideation-plan-${plan.version || "draft"}.pdf`);
};
